import { useState } from "react";
import { api } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { ArrowCounterClockwise } from "@phosphor-icons/react";
import { toast } from "sonner";

export function RestoreDialog({ target, onClose, onRestored }) {
  const [restoring, setRestoring] = useState(false);

  const confirm = async () => {
    setRestoring(true);
    try {
      await api.post(`/admin/deleted-accounts/${target.user_id}/restore`);
      toast.success(`Restored ${target.name || target.email}`);
      onRestored(target.user_id);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to restore account");
    } finally {
      setRestoring(false);
    }
  };

  return (
    <Dialog open={!!target} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-zinc-900 border-white/10">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <ArrowCounterClockwise size={18} className="text-emerald-400" /> Restore this account?
          </DialogTitle>
          <DialogDescription className="text-zinc-400">
            This brings back <span className="text-zinc-200">{target?.name || target?.email}</span> with their {target?.orgs_count || 0} workspaces and {target?.machines_count || 0} machines. Existing agents may need to reconnect.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="bg-transparent border-white/10 hover:bg-zinc-800" data-testid="cancel-restore">Cancel</Button>
          <Button onClick={confirm} disabled={restoring} className="bg-emerald-600 hover:bg-emerald-500" data-testid="confirm-restore">
            {restoring ? "Restoring…" : "Restore account"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
